import { isMac } from '@shared/utils/platform.ts'
import type { DockBounds, DockState, DockStateSource } from '@shared/types/display.ts'
import { EMPTY_DOCK_STATE } from '@shared/dock-snapshot'
import { useDockSnapshot } from '@renderer/overlay/hooks/use-dock-snapshot'

export type { DockBounds, DockState, DockStateSource }

/**
 * Read the derived Dock state published by the main process.
 *
 * The cache logic (debounce / settle timer / width fast-path / hide rescue) lives in
 * `dock-state-deriver.ts` so all renderer windows see one consistent value without each one
 * running its own React effect + timers.
 *
 * For "dock is about to show" UX, layer your own cursor-edge / proximity logic on top of this
 * state — neither this hook nor the publisher does mouse tracking.
 */
export function useDockState(): DockState {
  const { state } = useDockSnapshot()
  if (!isMac) {
    return EMPTY_DOCK_STATE
  }
  return state
}
